import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { pulse } from '@/lib/pulse'

export function AnalyticsTracker() {
  const location = useLocation()
  
  useEffect(() => {
    // Track pageview on route change
    pulse.pageview(location.pathname)
  }, [location])
  
  return null
}